import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "groups-page toggleswitch" }
const _hoisted_2 = { class: "groups-toolbar right-side-tool-bar" }
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-primary btn-size-header-main dropdown-toggle",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_8 = { class: "groups-toolbar" }
const _hoisted_9 = { class: "new-left-side-tool-bar groups-count" }
const _hoisted_10 = { class: "groups-table-wrapper" }
const _hoisted_11 = { class: "groups-table" }
const _hoisted_12 = { class: "col-name" }
const _hoisted_13 = { class: "col-count" }
const _hoisted_14 = { class: "col-source" }
const _hoisted_15 = { class: "col-toggle" }
const _hoisted_16 = { class: "col-name font-weight-600" }
const _hoisted_17 = { class: "col-count" }
const _hoisted_18 = { class: "col-source color-grey" }
const _hoisted_19 = { class: "col-toggle" }
const _hoisted_20 = { class: "switch" }
const _hoisted_21 = ["checked", "onChange"]
const _hoisted_22 = { class: "col-kebab" }
const _hoisted_23 = { class: "kebab-cell" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "drawer-label" }
const _hoisted_28 = { class: "manual-group-row" }
const _hoisted_29 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "auto-description" }
const _hoisted_32 = { class: "auto-instructions" }
const _hoisted_33 = { class: "auto-total-participants" }
const _hoisted_34 = { class: "drawer-form-group" }
const _hoisted_35 = { class: "drawer-label" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "drawer-form-group" }
const _hoisted_38 = { class: "drawer-label" }
const _hoisted_39 = {
  key: 0,
  class: "auto-per-group-hint"
}
const _hoisted_40 = { class: "drawer-form-group" }
const _hoisted_41 = { class: "drawer-label" }
const _hoisted_42 = { class: "drawer-form-group" }
const _hoisted_43 = { class: "drawer-checkbox-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_SideDrawer = _resolveComponent("SideDrawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showModalPopup)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.showModalPopup,
          "header-content": _ctx.modalPopupHeading,
          "body-heading": _ctx.modalPopupBodyHeading,
          "body-content": _ctx.modalPopupBodyContent,
          "show-cancel-button": _ctx.modalPopupShowCancelButton,
          "cancel-button-text": _ctx.modalPopupCancelButtonText,
          "confirm-button-text": _ctx.modalPopupConfirmButtonText,
          "show-close-button": _ctx.showCloseButton,
          "image-url": _ctx.deletePopupIcon,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmClick($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-cancel-button", "cancel-button-text", "confirm-button-text", "show-close-button", "image-url"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", _hoisted_4, [
            _createElementVNode("img", { src: _ctx.addIcon }, null, 8, _hoisted_5),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Groups.CreateNew')), 1),
            _createElementVNode("img", {
              src: _ctx.dropDownIcon,
              class: "margin-left-10 margin-right-0"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "dropdown-item cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OpenCreateManualDrawer && _ctx.OpenCreateManualDrawer(...args)))
            }, _toDisplayString(_ctx.$t('Groups.CreateManuallyFull')), 1),
            _createElementVNode("a", {
              class: "dropdown-item cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OpenCreateAutoDrawer && _ctx.OpenCreateAutoDrawer(...args)))
            }, _toDisplayString(_ctx.$t('Groups.CreateAutoFull')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Groups.NumberOfGroups', { count: _ctx.groupsListingData.length })), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('Groups.Name')), 1),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('Groups.NoOfParticipants')), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('Groups.Source')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('Groups.FilterableInApp')), 1),
            _cache[14] || (_cache[14] = _createElementVNode("th", { class: "col-kebab" }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsListingData, (group) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: group.Id,
              class: "groups-row"
            }, [
              _createElementVNode("td", _hoisted_16, _toDisplayString(group.Name), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(group.TotalParticipantCount), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(group.Source), 1),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: group.IsFilterableInApp,
                    onChange: ($event: any) => (_ctx.OnToggleFilterable(group))
                  }, null, 40, _hoisted_21),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "slider round" }, null, -1))
                ])
              ]),
              _createElementVNode("td", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "kebab-btn",
                    onClick: _withModifiers(($event: any) => (_ctx.ToggleGroupMenu(group.Id, $event)), ["stop"])
                  }, " ⋮ ", 8, _hoisted_24),
                  (_ctx.openMenuId === group.Id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["group-dropdown", { 'group-dropdown--above': _ctx.dropdownAbove }])
                      }, [
                        _createElementVNode("div", {
                          class: "group-dropdown-item padding-bottom-10",
                          onClick: ($event: any) => (_ctx.OpenEditDrawer(group))
                        }, _toDisplayString(_ctx.$t('Edit')), 9, _hoisted_25),
                        _createElementVNode("div", {
                          class: "group-dropdown-item",
                          onClick: ($event: any) => (_ctx.ShowDeletePopup(group))
                        }, _toDisplayString(_ctx.$t('Delete')), 9, _hoisted_26)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showCreateManualDrawer,
      title: _ctx.$t('Groups.CreateGroupsTitle'),
      "confirm-button-text": _ctx.$t('Groups.CreateButton'),
      "confirm-disabled": !_ctx.HasValidManualGroupName || _ctx.isCreating,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCreateManualDrawer = false)),
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCreateManualDrawer = false)),
      onConfirm: _ctx.ConfirmCreateManual
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manualGroupNames, (entry, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "drawer-form-group"
          }, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('Groups.GroupName')), 1),
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((_ctx.manualGroupNames[index]) = $event),
                type: "text",
                class: "form-control",
                placeholder: _ctx.$t('Groups.GroupNamePlaceholder')
              }, null, 8, _hoisted_29), [
                [_vModelText, _ctx.manualGroupNames[index]]
              ]),
              (_ctx.manualGroupNames.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "manual-group-remove",
                    onClick: ($event: any) => (_ctx.RemoveManualGroupEntry(index))
                  }, " × ", 8, _hoisted_30))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("a", {
          href: "javascript:void(0)",
          class: "add-another-link",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.AddAnotherGroup && _ctx.AddAnotherGroup(...args)))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "add-another-icon" }, "⊕", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Groups.AddAnother')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showCreateAutoDrawer,
      title: _ctx.$t('Groups.CreateAutoTitle'),
      "confirm-button-text": _ctx.$t('Groups.CreateButton'),
      "confirm-disabled": _ctx.autoNumberOfGroups < 1 || _ctx.isCreating,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showCreateAutoDrawer = false)),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showCreateAutoDrawer = false)),
      onConfirm: _ctx.ConfirmCreateAuto
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('Groups.CreateAutoDescription')), 1),
        _createElementVNode("ul", _hoisted_32, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Groups.CreateAutoInstruction1')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Groups.CreateAutoInstruction2')), 1)
        ]),
        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Groups.TotalParticipants', { count: _ctx.totalParticipants })), 1),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('Groups.AssignGroupPrefix')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.autoGroupPrefix) = $event)),
            type: "text",
            class: "form-control",
            placeholder: _ctx.$t('Groups.PrefixPlaceholder')
          }, null, 8, _hoisted_36), [
            [_vModelText, _ctx.autoGroupPrefix]
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, [
            _createTextVNode(_toDisplayString(_ctx.$t('Groups.NumberOfGroupsToCreate')), 1),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "required-star" }, "*", -1))
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.autoNumberOfGroups) = $event)),
            type: "number",
            class: "form-control",
            min: "1"
          }, null, 512), [
            [
              _vModelText,
              _ctx.autoNumberOfGroups,
              void 0,
              { number: true }
            ]
          ]),
          (_ctx.autoNumberOfGroups > 0)
            ? (_openBlock(), _createElementBlock("small", _hoisted_39, " (" + _toDisplayString(_ctx.$t('Groups.ParticipantsPerGroup', { count: _ctx.participantsPerGroup })) + ") ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showEditDrawer,
      title: _ctx.$t('Groups.EditGroupTitle'),
      "confirm-disabled": _ctx.editGroupName.trim() === '',
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEditDrawer = false)),
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showEditDrawer = false)),
      onConfirm: _ctx.ConfirmEdit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('Groups.GroupName')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editGroupName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.editGroupName]
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("label", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editFilterableInApp) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.editFilterableInApp]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Groups.IsFilterableInApp')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-disabled", "onConfirm"])
  ]))
}